import gql from 'graphql-tag';

export const leaveDivisionMutation = gql`
	mutation LeaveDivision($id: ID!) {
		leaveDivision(id: $id) {
			id
		}
	}
`;
